import React from "react";
import Modal from "../ui/Modal";

const NavigatingPrototypePopup = ({ open, onClose, transformOrigin }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      transformOrigin={transformOrigin}
      className="p-10 md:p-12"
      childrenClassName="!max-h-[80vh]"
    >
      <div className="grid gap-5 md:grid-cols-[1.1fr_1.9fr] md:gap-12">
        <div className="flex flex-col items-center justify-center">
          <img
            src="/assets/svgs/nvp_1.svg"
            alt="The Web of Care"
            className=""
          />
          <img
            src="/assets/svgs/nvp_2.svg"
            alt="The Web of Care"
            className=""
          />
        </div>

        <div className="text-base leading-loose text-softBlack">
          <h2 className="text-[26px] sm:text-[32px] font-bold text-black font-playfair leading-normal mb-2">
            Navigating the visuals
          </h2>
          <p className="">
            Each topic is represented as an infographic which when clicked leads
            to the reading material. The reading material begins with a general
            introduction to the topic, significant global statistics and
            relevant highlights. It then narrows down into the country specific
            contexts within the <strong>Nooraverse.</strong>
          </p>
          <p className="mt-1">
            The topics also create linkages to the work we do at Noora Health,
            where relevant.
          </p>
          <p className="mt-5">
            The visuals can be navigated by clicking on the relevant topics of
            interest or country-specific data, that lead to the relevant
            sections that elaborate them; connections to another topic are also
            highlighted.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default NavigatingPrototypePopup;
